import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import AstronMembersTable from "../../../components/apps/astronmembers/AstronMembersTable";
import { useNavigate } from "react-router";

export default function AstronMembers() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - AstronMembers"
                description="AstronMembers"
            />
            <PageBreadcrumb
                pageTitle="AstronMembers"
                showBackButton={true}
                onBack={handleGoBack}
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">

                <div className="col-span-12 space-y-6">
                    <AstronMembersTable />
                </div>
            </div>
        </>
    );
}
